import {
    API_END_POINT_COMPANIO_WORK,
    API_END_POINT_COMPANY,
    API_END_POINT_DOCUMENTS,
    API_END_POINT_DOWNLOAD, API_END_POINT_MULTIPLE, API_END_POINT_EOR_PARTNER_INVOICE,
    API_END_POINT_ID, API_END_POINT_INTERNAL
} from "../utils/constants";
import {currentAccessToken} from "../utils";


export const downloadDocument = (documentId: string, companyId: string) => {
    const endpoint = `${API_END_POINT_COMPANIO_WORK}${API_END_POINT_DOCUMENTS}${API_END_POINT_DOWNLOAD}${API_END_POINT_ID}/${documentId}${API_END_POINT_COMPANY}/${companyId}?Authorization=${currentAccessToken()}`
    window.open(process.env.REACT_APP_API_URL + endpoint, '_blank')

}

export const downloadMultipleCompanioDocuments = (documentIds:string[]) => {
    const endpoint = `${API_END_POINT_COMPANIO_WORK}${API_END_POINT_DOCUMENTS}${API_END_POINT_DOWNLOAD}${API_END_POINT_MULTIPLE}${API_END_POINT_INTERNAL    }?Authorization=${currentAccessToken()}&ids=${JSON.stringify(documentIds)}`
    window.open(process.env.REACT_APP_API_URL + endpoint, '_blank')
}

export const downloadEorPartnerInvoice = (documentId: string) => {
    const endpoint = `${API_END_POINT_COMPANIO_WORK}${API_END_POINT_DOCUMENTS}${API_END_POINT_EOR_PARTNER_INVOICE}${API_END_POINT_DOWNLOAD}${API_END_POINT_ID}/${documentId}?Authorization=${currentAccessToken()}`
    window.open(process.env.REACT_APP_API_URL + endpoint, '_blank')
}
